var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c(
          "swiper",
          {
            ref: "mySwiper",
            staticClass: "home-swiper",
            attrs: { options: _vm.swiperOption },
          },
          [
            _c("swiper-slide", [
              _c("img", {
                attrs: { src: require("../images/home-bg-header.jpg") },
              }),
            ]),
            _vm._v(" "),
            _c("swiper-slide", [
              _c("img", {
                attrs: { src: require("../images/home-bg-header-1.png") },
              }),
            ]),
            _vm._v(" "),
            _c("swiper-slide", [
              _c("img", {
                attrs: { src: require("../images/home-bg-header-2.png") },
              }),
            ]),
            _vm._v(" "),
            _c("swiper-slide", [
              _c("img", {
                attrs: { src: require("../images/home-bg-header-3.png") },
              }),
            ]),
            _vm._v(" "),
            _c("swiper-slide", [
              _c("img", {
                attrs: { src: require("../images/home-bg-header-4.png") },
              }),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "swiper-pagination",
              attrs: { slot: "pagination" },
              slot: "pagination",
            }),
          ],
          1
        ),
        _vm._v(" "),
        false
          ? _c(
              "div",
              { staticClass: "search" },
              [
                _c("svgicon", {
                  attrs: { name: "search", width: ".3rem", height: ".3rem" },
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "search-input",
                  attrs: {
                    type: "text",
                    placeholder: "输入小区或商圈开始找房咯~",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "nav" },
      [
        _c(
          "router-link",
          { staticClass: "catagery", attrs: { to: "/list/2" } },
          [
            _c("svgicon", {
              attrs: { name: "secondhandhouse", width: "1rem", height: "1rem" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "catagery-title" }, [_vm._v("二手房")]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "router-link",
          { staticClass: "catagery", attrs: { to: "/xingfang/list" } },
          [
            _c("svgicon", {
              attrs: { name: "newhouse", width: "1rem", height: "1rem" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "catagery-title" }, [_vm._v("新房")]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "router-link",
          { staticClass: "catagery", attrs: { to: "/list/3" } },
          [
            _c("svgicon", {
              attrs: { name: "renthouse", width: "1rem", height: "1rem" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "catagery-title" }, [_vm._v("租房")]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "house-tianjian" },
      _vm._l(_vm.list, function (house, index) {
        return _c("house-item", {
          key: index,
          attrs: { house: house, type: "2" },
          on: { handleHosue: _vm.handleHosue },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }